import SystemFieldProto from '../../proto/system-field-proto'
import PrioritySelector from '../../../gd-components/priority-selector/priority'
// @ts-ignore
import SystemFieldPriorityViewInImport from "./components/view-in-import"

export default class PriorityField extends SystemFieldProto {

    constructor(entityType:any) {
        super(entityType)
        this.type = gd.const.fields.type.PRIORITY
    }

    get sortHintMessage() {
        return 'Sort by priority'
    }

    getCsvValue(item:any) {
        let res = item.priority
        const priorities = gd.session.companies.get(item.companyId).priorities
        if (priorities['priority'+item.priority]) res = priorities['priority'+item.priority]
        return res
    }

    // @ts-ignore - base returns () => number sort functions
    listItemSortFunctions(sort:any) {
        return {
            functions   : [(i:any) => -i.item.priority],
            directions  : [sort]
        }
    }

    // @ts-ignore - base declares boolean return
    getRenderComponent() {
        switch (this.entityType) {
            case gd.const.entityType.PROJECT:
            case gd.const.entityType.TASK:
                return PrioritySelector
            default:
                throw new Error(this.constructor.name + ': getRenderComponent is not available')
        }
    }

    normalizeCSVValue(value:any) {

        const priorities = gd.session.companies.get(gd.companyId).priorities

        let intValue

        // Try map by number
        intValue = parseInt(value)
        if (intValue && priorities.getName(intValue)) {

            if (priorities["priority"+intValue]) {
                return intValue
            } else {
                return null
            }

        }

        // try map by string
        intValue = priorities.getValueByName(value)
        if (intValue) {
            return intValue
        }

        return null
    }

    getComponentViewInImport() {
        return SystemFieldPriorityViewInImport
    }

}
